var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var defaultOptions = {
    'buttonId': 'hamburger',
    'menuId': 'nav-menu',
    'eventName': 'click',
    'hideClass': 'd-none',
    'showClass': 'show-menu'
};
var buttonId = defaultOptions.buttonId, menuId = defaultOptions.menuId, eventName = defaultOptions.eventName, hideClass = defaultOptions.hideClass, showClass = defaultOptions.showClass;
var menuElement = document.getElementById(menuId);
var classes = menuElement.classList;
export default function hamburger(document, options) {
    if (options === void 0) { options = defaultOptions; }
    defaultOptions = __assign(__assign({}, defaultOptions), options);
    var hamburgerElement = document.getElementById(buttonId);
    hamburgerElement.addEventListener(eventName, function () {
        classes.toggle(hideClass);
        classes.toggle(showClass);
    });
    return hamburgerElement;
}
